import { Box } from "react-bootstrap-icons";
import avaBox from "../../../assets/pic/avaBox.png";
import avaShop from "../../../assets/pic/avashop.png";
import useSharedData from "../../../hooks/useSharedData";
import avaType from "../../../utilities/ava/avaType";
import "./logo.css";

function HeaderSection({ type = 1, mustCollected, partCount }) {
  const { isAgent } = useSharedData();

  return (
    <section>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h1 className="mb-4">ثبت سفارش {avaType[type].title}</h1>
        <div className="text-center mx-auto ms-sm-0">
          <img
            className={`w-100 h-100 object-fit-contain ${
              type === 1 ? "shop-logo" : "box-logo"
            }`}
            src={type === 1 ? avaShop : avaBox}
          />
        </div>
      </div>

      <div>
        {type === 2 && isAgent && (
          <div className="text-start">
            <div
              className="h4 bg-uncollected-agent"
              style={{ color: "#E50000" }}
            >
              <Box size={25} style={{ color: "#482b88" }} className="m-1" /> :{" "}
              {mustCollected} سفارش شامل {partCount} بسته در انتظار جمع آوری
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default HeaderSection;
